import React from 'react'
import { NoDataImage } from '../Icons'

const NoDataFound = ({headText, infoText = null}) => {
  return (
    <div className='no-data-found'>
        <NoDataImage/>
        <div className='info-here'>
            <h6>{headText}</h6>
            { infoText && <p>{infoText} </p> }
        </div>
    </div>
  )
}

export default NoDataFound